import React from 'react';

import { MonthPicker } from '@gogame/components';
import { withFormField } from '@gogame/form';
import { toISOString, fromTimeZoneToUTC, dateFNS } from '@gogame/intl-ts';

export default withFormField()(({
  label,
  value,
  onChange,
  disabled,
  required,
  error,
}) => {
  const handleChange = React.useCallback(
    (e, monthValue) => {
      onChange(e, [
        monthValue,
        toISOString(
          fromTimeZoneToUTC(
            dateFNS.startOfDay(dateFNS.endOfMonth(new Date(monthValue)))
          )
        ),
      ]);
    },
    [value]
  );

  return (
    <MonthPicker
      label={label}
      value={value?.[0]}
      onChange={handleChange}
      disabled={disabled}
      required={required}
      error={error}
    />
  );
});
